// State -> { [Id]: Participant }
import UiStateSelectors from '../../ui-state/ui-state-selectors.js'
import PresenceSelectors from '../presence-slice/presence-selectors.js'

const empty = {}

const organizationParticipants = state => UiStateSelectors.selectedOrganization(state)?.participants || {}

/*
 * Return the user with the specified id
 * @sig organizationParticipantWithId :: (State, String) -> User|Participant|undefined
 */
const organizationParticipantWithId = (state, userId) => organizationParticipants(state)[userId]

/*
 * The project.participants for the selected Project
 */
const selectedProjectParticipants = state => {
    const project = UiStateSelectors.selectedProject(state)
    return project?.participants || empty
}

const selectedProjectParticipantWithId = (state, id) => selectedProjectParticipants(state)[id]
const selectedProjectParticipantsAsArray = state => Object.values(selectedProjectParticipants(state))

/*
 * Return all the Users who have recent Presences
 * @sig presentProjectParticipants :: State -> [Participant]
 */
const presentProjectParticipants = state => {
    const reducer = (acc, p) => acc.concat(_users[p.id])

    const _presences = PresenceSelectors.presences(state)
    const _users = selectedProjectParticipants(state)
    return _presences.reduce(reducer, [])
}

// ---------------------------------------------------------------------------------------------------------------------
// API
// ---------------------------------------------------------------------------------------------------------------------

const ParticipantSelectors = {
    organizationParticipantWithId,
    presentProjectParticipants,
    selectedProjectParticipants,
    selectedProjectParticipantsAsArray,
    selectedProjectParticipantWithId,
}

export default ParticipantSelectors
